<template xmlns="http://www.w3.org/1999/html">
    <section>
        <PageTitle title="QR Analytics" v-bind:crumbs="[{href:'/home',title:'Home'},{href:'/qr_analytics',title:'QR Analytics'}]" />
        <div class="wrapper wrapper-content">
            <div class="ibox-content c2d_cont_1">
                <div class="row">
                    <AdminFiltersComponent
                        v-if="userRole === 'ROLE_ADMIN' || userRole === 'ROLE_USER' "
                        @restaurant="(value) => updateRestaurantInformationAndFetchBranchesStats(value)"
                    />
                    <div v-if="restaurantId !== 0">
                        <div class="col-md-2 pull-right">
                            <h3>Total Scans</h3>
                            <h4>
                                <b class="total_scans">
                                    {{QRAnalyticsStats.totalScans}}
                                </b> / <b class="unique_scans">
                                    {{QRAnalyticsStats.uniqueScans}} Unique
                                </b>
                            </h4>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" v-if="QRAnalyticsStats.restaurantId !== 0">
                <br/>
                <div class="col-lg-12">
                    <div v-for="(branchStats, index) in QRAnalyticsStats.branchQRStats">
                        <div class="ibox-content">
                            <div class="row">
                                <QRAnalyticsCounts
                                    :branch-stats="branchStats"
                                    :id="index"
                                    @updateBranchQRCodeStatus="(branchId, isDeleted) => updateBranchQRCodeStatus(branchId, isDeleted)"
                                />
                            </div>
                          <q-r-analytics-graphs
                              :branch-stats="branchStats"
                              :id="index"
                              :restaurant-id="restaurantId"
                              :restaurant-name="restaurantName"
                              :load-q-r-stats="loadQRStats"
                          />
                        </div>
                        <br/>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import PageTitle from "@/components/layout_components/PageTitle.vue";
import AdminFiltersComponent from "@/components/QrAnalytics/AdminFiltersComponent.vue";
import QRAnalyticsCounts from "@/components/QrAnalytics/QRAnalyticsCounts.vue";
import {getRestaurantQRAnalytics} from "@/api/FirestoreRestaurant";
import QRAnalyticsGraphs from "@/components/QrAnalytics/QRAnalyticsGraphs.vue";

export default {
    name: "QRAnalytics",

    components: {
      QRAnalyticsGraphs,
        QRAnalyticsCounts,
        AdminFiltersComponent,
        PageTitle
    },

    computed: {
        userRole() {
            return this.$store.getters.user.userRolesById[0].role;
        },
    },

    data(){
        return {
            restaurantId: 0,
            restaurantName: "",
            loadQRStats: true,
            QRAnalyticsStats: {
                "restaurantId":0,
                "restaurantName":"",
                "totalScans":0,
                "uniqueScans":0,
                "created":null,
                "updated":null,
                "branchQRStats":[{
                    "branchId":0,
                    "branchName":"",
                    "qrCode":"",
                    "disabled": false,
                    "totalScans":0,
                    "uniqueScans":0,
                    "created":"",
                    "modified":"",
                    "scansOverTimeStats":[],
                    "scansByOperatingSystem":[],
                    "scansByCountries":[],
                    "scansByCities":[]
                }]
            },
        }
    },

    methods:{
        updateRestaurantInformationAndFetchBranchesStats: async function (value) {
            this.loadQRStats = true
            this.restaurantId = value.id
            this.restaurantName = value.name
            let params = new URLSearchParams();
            params.append("restaurant_id", this.restaurantId);
            params.append("restaurant_name", this.restaurantName);
            params.append("year", new Date().getFullYear());
            params.append("month", new Date().getMonth()+1);
            params.append("find_by", "day");
            let restaurantQRAnalyticsDetailsResp = await getRestaurantQRAnalytics(params)
                .catch( ex => {
                    this.showErrorMessage(ex)
                });
            if(restaurantQRAnalyticsDetailsResp.data.status === 200){
              this.$store.dispatch('updateCollapseValue', 0);
              $('.collapse:not(#collapse_0:visible)').collapse('hide');
              $('#collapse_0').collapse('show');
              this.QRAnalyticsStats = restaurantQRAnalyticsDetailsResp.data.body;
              this.loadQRStats = false
            }else{
                this.showErrorMessage(restaurantQRAnalyticsDetailsResp.data.message)
            }
        },

        updateBranchQRCodeStatus: function (branchId, isDeleted){
           let index = this.QRAnalyticsStats.branchQRStats.indexOf(
               this.QRAnalyticsStats.branchQRStats.filter(
                branches => branches.branchId === branchId
               )[0]
           );
           if(isDeleted){
               this.QRAnalyticsStats.branchQRStats[index].deleted = !this.QRAnalyticsStats.branchQRStats[index].deleted;
           }else {
               this.QRAnalyticsStats.branchQRStats[index].disabled = !this.QRAnalyticsStats.branchQRStats[index].disabled;
           }
            console.log('QRAnalyticsStats: ', this.QRAnalyticsStats)
        },
    }
}
</script>

<style scoped>
.total_scans{
    font-size: 35px;
    font-weight: 700;
    color: #1ab394;
}
.unique_scans {
    font-weight: 600;
    color: grey;
}
.ibox-content {
  position: relative;
  overflow: visible !important;
}

</style>